import React from 'react';
import { AlertCircle } from 'lucide-react';

// Returns the options array when the API asks the user to pick owned vs consigned stock.
export const getStockRowOptions = (err) => {
  const detail = err?.response?.data?.detail;
  return detail && detail.code === 'stock_row_selection_required' ? detail.options || [] : null;
};

export const apiErrorText = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail.message === 'string') return detail.message;
  return fallback;
};

export const StockRowChoice = ({ options, value, onChange }) => {
  if (!options?.length) return null;
  return (
    <div className="space-y-2 rounded-lg border border-amber-200 bg-amber-50 p-3" data-testid="stock-row-choice">
      <p className="flex items-center gap-2 text-sm font-medium text-amber-900">
        <AlertCircle className="h-4 w-4" /> Choose which stock to use
      </p>
      {options.map((o) => (
        <label key={o.warehouse_inventory_id} className="flex cursor-pointer items-center gap-2 text-sm"
          data-testid={`stock-row-option-${o.ownership_type}`}>
          <input type="radio" name="stock-row" checked={value === o.warehouse_inventory_id}
            onChange={() => onChange(o.warehouse_inventory_id)} />
          <span className="font-medium">{o.ownership_type === 'consigned' ? `Consigned${o.vendor_name ? ` (${o.vendor_name})` : ''}` : 'Owned'}</span>
          <span className="text-muted-foreground">— {o.available} available of {o.qty_on_hand} on hand</span>
        </label>
      ))}
    </div>
  );
};
